import React, { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import { Grid, Radio } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import dayjs from "dayjs";
import { itemsPerPage } from "../../utils/constants";
import TablePagination from "../../common/tablePagination";
import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";
import capRegistrationActions from "../../redux/capRegistration/actions";

export default function CapcategoryTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { backofficeTokenDetails } = useSelector(state => state.authReducer);
  const { capCategories } = useSelector(state => state.capReducer)
  console.log(capCategories, 'capCategories')
  // let candDocData = [ {
  //     categoryid: 1,
  //     category:"All Candidates",
  //     documents:"SSLC,HSc,Degree",
  //     Documentid:[]
  // }]
  const { capDocuments } = useSelector(state => state.capReducer)
  const [tableData, setTableData] = useState([

  ]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const createTabledata = (capCategories) => {
    if (!capCategories || !Array.isArray(capCategories)) return;

    let data = capCategories.map((obj, index) => ({
      id: index + 1,
      categoryid: obj.categoryid,
      category: obj.category || "N/A",
      documents: obj.document_names,
      enable: (
        <Radio
          checked={obj.status === "1"}
          onClick={() => handleActive(obj.status, "1", obj.categoryid,obj)}
        />
      ),
      disable: (
        <Radio
          checked={obj.status === "0"}
          onClick={() => handleActive(obj.status, "0", obj.categoryid,obj)}
        />
      ),
    }));

    setTableData(data);
  };
  useEffect(()=>{
dispatch({type:capRegistrationActions.GET_CAP_CATEGORY})
  },[])
  useEffect(() => {
    createTabledata(capCategories)
  }, [capCategories]);


  const handleActive = (active, type, eligibilitycriteriaid,exdata) => {
    if (type !== active) {
      let data = {
        ...exdata,
        userid: backofficeTokenDetails?.id,
        status: type
      }
      dispatch({
        type: capRegistrationActions.UPDATE_CAP_CATEGORY,
        payload: { data: data },
      });
    }
  }






  useEffect(() => {
    dispatch({ type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT })
  }, [])
  const tableKeys = [
    {
      name: "S.No",
      accessor: "id",
      sortOption: false,
    },
    {
      name: "category Name",
      accessor: "category",
      sortOption: false,
    },
    {
      name: "category Documents",
      accessor: "documents",
      sortOption: false,
    },
    {
      name: "Enable",
      accessor: "enable",
      sortOption: false,

    },
    {
      name: "Disable",
      accessor: "disable",
      sortOption: false,
    },
  ];



  const handlecategoryUpdate = (val) => {
    console.log(val, 'Val')
    navigate(`/${Cookies.get("mhet_mst_project")}/cap-category-document?page=updatecapcategorydocument`, { state: { id: val } });
  }



  const endOffset = itemOffset + itemsPerPage;
  const currentItems = tableData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(tableData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };

  return (
    <Grid>
      <DataTable
        keys={tableKeys}
        values={currentItems}
        page={"category-documentlist"}
        handlecategoryUpdate={handlecategoryUpdate}
      />
      <TablePagination
        pageCount={pageCount}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
      />
    </Grid>
  );
}
